import { configureStore } from '@reduxjs/toolkit';
import { advancedAnalyticsApi } from './queries/advancedAnalytics';
import { customerActivitiesApi } from './queries/customerActivities';
import { integrationsApi } from './queries/integrations';
import { vendorApi } from './queries/vendor';
import { vendorCustomerDetailsApi } from './queries/vendorCustomerDetails';
import { internalDashboardApi } from './internalDashboardApi';
import { rootReducer } from './reducers/rootReducer';
import { createDebouncedUndoMiddleware } from './utils/undoable';

export const setupStore = (preloadedState) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(createDebouncedUndoMiddleware(['inventoryPricing']))
        .concat([
          integrationsApi.middleware,
          vendorApi.middleware,
          advancedAnalyticsApi.middleware,
          customerActivitiesApi.middleware,
          vendorCustomerDetailsApi.middleware,
          internalDashboardApi.middleware,
        ]),
  });
